import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-pulse-participation',
  templateUrl: './pulse-participation.component.pug',
  styleUrls: ['./pulse-participation.component.scss'],
  standalone: false
})
export class PulseParticipationComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() request!: any;
  @Input() survey!: any;
  @Input() department!: any;
  @Input() filterBy!: any;
  state = 'participated'
  previousState = '';

  sectionLoading = true;
  private overallSectionLoaded = false;
  private trendSectionLoaded = false;

  constructor() {
  }

  switchState(newState) {
    if (this.previousState !== newState) {
      this.state = newState;
      this.previousState = newState;
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const inputs = ['start', 'end', 'request', 'survey', 'department', 'filterBy'];
    const hasRelevantChange = inputs.some((key) => changes[key] && !changes[key].firstChange);
    if (hasRelevantChange) {
      this.resetSectionLoading();
    }
  }

  onOverallLoaded(): void {
    this.overallSectionLoaded = true;
    this.checkAllSectionsLoaded();
  }

  onTrendLoaded(): void {
    this.trendSectionLoaded = true;
    this.checkAllSectionsLoaded();
  }

  private checkAllSectionsLoaded(): void {
    if (!this.overallSectionLoaded || !this.trendSectionLoaded) {
      return;
    }
    this.sectionLoading = false;
  }

  private resetSectionLoading(): void {
    this.overallSectionLoaded = false;
    this.trendSectionLoaded = false;
    this.sectionLoading = true;
  }
}
